<template>
    <SocialAuthBtn
        id="google-login-btn"
        :img="GoogleLogo"
        :label="$t('shared.loginModule.socialAuthBtns.continueWithGoogle')"
        color="white"
        class="google-btn"
        @click="gLogin"
        :tiny="tiny"
    />
</template>

<script>
import SocialAuthBtn from './SocialAuthBtn';
import GoogleFlow from '~/utils/socialAuth/GoogleFlow';

// Assets
import GoogleLogo from '~/assets/img/GoogleLogo.png';

export default {
    name: 'GoogleLoginBtn',
    components: { SocialAuthBtn },
    props: {
        redirectPath: String,
        tiny: Boolean,
    },
    data() {
        return {
            GoogleLogo,
        };
    },
    methods: {
        async gLogin() {
            let queryObject = {
                redirectUrl: this.$interfaces.logInModule.getRedirect() || this.$route.path,
            };

            GoogleFlow.startAuthFlow(this.redirectPath, queryObject, this.$route.query || {});
        },
    },
};
</script>

<style>
.google-btn {
    color: black !important;
    border: thin solid #ddd !important;
}

.google-btn > img {
    margin-right: 38px !important;
    width: 25px !important;
    height: 25px !important;
}
</style>
